import { IExportColumnModel } from "../../../../../shared/models";

export const ScopeSchemaChangesColumnList: IExportColumnModel[] = [
]